var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    viewBox: "0 0 75 75",
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 .223h44.95V74H15Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9a92c",
    d: "M52.008.445c1.664 0 3.336.59 4.672 1.79a7.003 7.003 0 0 1 .539 9.894L32.78 39.387 56.758 61.52a7.003 7.003 0 0 1 .394 9.898 7.003 7.003 0 0 1-9.898.398L18.204 45a7.008 7.008 0 0 1-.466-9.824L46.79 2.773A6.987 6.987 0 0 1 52.008.445Zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.5e86f192a0ce50e60b0f31886c46e6ef.svg";
export { ForwardRef as ReactComponent };